import { GlobalUtility } from '../service/global-utility.service'
import { AlertsService } from '../service/alerts.service'
import { POS_CODE } from '../service/constants.service'

export const appMixins = {
  data () {
    return { demoData: 'Hellow World' }
  },

  methods: {
    capitalize (e, o, prop) {
      this.$set(o, prop, e.target.value.toUpperCase())
    },

    capitalizeObject (value) {
      return GlobalUtility.capitalizeProperties(value)
    },

    decapitalizeObject (value) {
      return GlobalUtility.deCapitalizeProperties(value)
    },

    isActiveRoute (routeName, exceptions = []) {
      const routes = this.$route.matched
      let active = false
      routes.forEach(route => {
        if (route.name === routeName || exceptions.includes(route.name)) {
          active = true
        } else {
          active = false
        }
      })
      return active
    },

    titleCase (str) {
      if (str) {
        const splitStr = str.toLowerCase().split(' ')
        for (let i = 0; i < splitStr.length; i++) {
          splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1)
          if (splitStr[i] === 'And') {
            splitStr[i] = splitStr[i].toLowerCase()
          } else if (splitStr[i] === '(jiss)') {
            splitStr[i] = splitStr[i].toUpperCase()
          } else if (splitStr[i] === '(pni)') {
            splitStr[i] = splitStr[i].toUpperCase()
          } else if (splitStr[i] === 'Tnkc') {
            splitStr[i] = splitStr[i].toUpperCase()
          }
        }
        // Directly return the joined string
        return splitStr.join(' ')
      }
    },

    goBack () {
      this.$router.go(-1)
    },

    viewPdfFile (pdf_obj) {
      console.log('opening file.')
      const win = window.open('', '_blank')
      const pdf = pdf_obj
      const html = `
            <html>
              <title>Manning Document</title>
              <body style="margin:0!important;">
                <object width="100%" height="100%" data="${pdf}" type="application/pdf"></object>
              </body>
            </html>`
      win.document.write(html)
      win.document.close()
    },

    base64ToBlob (pdf_obj) {
      const binaryString = window.atob(pdf_obj)
      const len = binaryString.length
      const bytes = new Uint8Array(len)
      for (let i = 0; i < len; ++i) {
        bytes[i] = binaryString.charCodeAt(i)
      }
      const blob = new Blob([bytes], { type: 'application/pdf' })
      const fileUrl = URL.createObjectURL(blob)
      window.open(fileUrl)
    },

    // error
    errorAlert (text, actionType) {
      const act = actionType || ''
      const msg = text || ''
      return AlertsService.errorActionAlert(msg, act)
    },

    // info
    infoAlert (text, actionType) {
      const act = actionType || ''
      const msg = text || ''
      return AlertsService.infoActionAlert(msg, act)
    },

    // question
    async questionAlert (text, actionType, icon) {
      const iconQ = icon || 'question'
      const act = actionType || ''
      const msg = text || ''
      return await AlertsService.questionActionAlert(msg, act, iconQ)
    },

    // success
    successAlert (text, actionType, html) {
      const act = actionType || ''
      const msg = text || ''
      const ht = html || ''
      return AlertsService.successActionAlert(msg, act, ht)
    },

    // warning
    warningAlert (text, actionType) {
      const act = actionType || ''
      const msg = text || ''
      return AlertsService.warningActionAlert(msg, act)
    },

    errorConflict (text, actionType) {
      return AlertsService.errorWithResponseData(text, actionType)
    },

    // loading
    async loadingAlert (text) {
      return await AlertsService.loading(text)
    },

    limiteTextRemarks (limitField, limitCount, limitNum) {
      const field = document.getElementById(`${limitField}`)
      const count = document.getElementById(`${limitCount}`)
      if (field && field.value.length != undefined && count) {
        if (field.value.length > limitNum && field) {
          field.value = field.value.substring(0, limitNum)
        } else {
          count.value = limitNum - field.value.length
        }
      }
    },

    formatDate (date) {
      const d = date ? new Date(date) : new Date()
      let month = '' + (d.getMonth() + 1)
      let day = '' + d.getDate()
      const year = d.getFullYear()

      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day

      return [year, month, day].join('-')
    }
  },
  computed: {

    isSystemAdmin () {
      const code = localStorage.getItem(POS_CODE)
      if (code == 'sys-adm') {
        return true
      }
      return false
    },

    isDocAssistant () {
      const code = localStorage.getItem(POS_CODE)
      if (code == 'doc-asst') {
        return true
      }
      return false
    },

    isDocSupervisor () {
      const code = localStorage.getItem(POS_CODE)
      if (code == 'dss-supv' || code == 'docs-supv') {
        return true
      }
      return false
    },

    isCrewOfficer () {
      const code = localStorage.getItem(POS_CODE)
      if (code == 'co') {
        return true
      }
      return false
    },

    isOpsOfficer () {
      const code = localStorage.getItem(POS_CODE)
      if (code == 'ops-ofcr' || code == 'ops-asst') {
        return true
      }
      return false
    },

    isBldgAdmin () {
      const code = localStorage.getItem(POS_CODE)
      if (code == 'bldg-adm') {
        return true
      }
      return false
    }
  }
}

export default { appMixins }
